import React, { useEffect } from "react";
import { FormattedMessage } from 'react-intl';
import PropTypes from "prop-types";
import DealerLocationCard from "../DealerLocationCard/DealerLocationCard"

const DealerPage = ({ dealerLocations, userLocation, ip, uuid }) => {
  useEffect(() => {
    document.title = `${process.env.REACT_APP_PAGES_DEALERS_TITLE} - Austin Energy EV Buyers Guide`;
  });

  let dealers = dealerLocations || [];

  let dealerLocationCards = dealers.map((dealer, i) => {
    return <DealerLocationCard key={i} dealerLocation={dealer} />;
  });

  return (
    <section className="container">
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <div className="banner-center">
              <p className="dealer-page-title">
                <FormattedMessage
                  id="dealersHeading"
                  defaultMessage="Locally Owned EV Dealers"
                  description="Dealers Title"
                />
              </p>   
              <p className="dealer-lead">
                <FormattedMessage
                  id="dealersSubheading"
                  defaultMessage="The dealers below work closely with Austin Energy to provide a great EV shopping experience. Contact and visit these dealers with the confidence that they'll help you pick the right vehicle for you."
                  description="Dealers Sub Title"
                />
              </p>
            </div>
          </div>
        </div>
        <div className="dealer-row">{dealerLocationCards}</div>
      </div>
    </section>
  );
};

export default DealerPage;

DealerPage.propTypes = {
  chargingStations: PropTypes.array,
  userLocation: PropTypes.object,
  ip: PropTypes.string,
  uuid: PropTypes.string
};
